export const INVITE_TYPE = {
  clubMember: 'club-member',
  clubSupervisor: 'club-supervisor',
  associationOffice: 'association-office',
  expertAssign: 'expert-assign',
  transferParticipation: 'transfer-participation',
};
